export const enum RouteAuth {
  loginWeb = 'login-web',
  register = 'register',
  forgotPassword = 'forgot-password',
  resetPassword = 'reset-password',
}
